
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';
import { useToast } from '@/common-utils/hooks/use-toast';
import actionsSubscriptions from '../../api/actionsSubscriptions';
import actionsPosTerminals from '../../../terminals/api/actionsPosTerminals';
import { DateTime } from 'luxon';
import { nsSubscription } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalTerminateSubscription Component
 */
function ModalTerminateSubscription({ trigger, isOpen, setIsOpen, subscriptionId, setLaunchRefetch }) {

    // Constants
    const BLACKLIST_START_DATE = DateTime.now();

    // Toast
    const { toast } = useToast();

    // API Calls
    const submitTerminateSubscription = actionsSubscriptions.terminateSubscription(() => { }, () => { });
    const submitBlacklistPosTerminal = actionsPosTerminals.blacklistPosTerminal(() => { }, () => { });

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.terminate.title'} namespace={nsSubscription} />
            <ModalBody>
                <Entity entity={'modal.terminate.text'} namespace={nsSubscription} />
            </ModalBody>
            <FooterForm
                onSubmit={async () => {
                    try {
                        await submitTerminateSubscription.mutateAsync({ subscriptionId });
                        await submitBlacklistPosTerminal.mutateAsync({
                            subscriptionId,
                            BLACKLIST_START_DATE
                        });
                        setLaunchRefetch(true);
                        toast({
                            description: <Entity entity={'modal.terminate.success'} namespace={nsSubscription} />,
                            variant: 'success'
                        });
                        setIsOpen(false);
                        // eslint-disable-next-line no-unused-vars
                    } catch (error) {
                        toast({
                            description: <Entity entity={'modal.terminate.error'} namespace={nsSubscription} />,
                            variant: 'danger'
                        });
                        setIsOpen(false);
                    }
                }}
                isSubmitting={submitTerminateSubscription.isLoading || submitBlacklistPosTerminal.isLoading}
                isSubmitDisabled={submitTerminateSubscription.isLoading || submitBlacklistPosTerminal.isLoading}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalTerminateSubscription.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalTerminateSubscription;